import { ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel } from '@rover/rsdk/src/apiClient/latest/model/apiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel';

export type PriceTransparencyLevel =
  ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel;

export const PriceTransparencyLevels =
  ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel;
